import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';

import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

export default () => (
  <SectionContainer
    id='life-insurance-faq-change-the-beneficiary'
    backgroundVariant='lightB'
    themeType='lightTheme'>
    <Row align='center'>
      <Col medium={8}>
        <Typography
          component='h2'
          nextElement='typography'
          align='center'>
          Change the Beneficiary
        </Typography>
        <Typography
          component='h3'
          nextElement='typography'>
          &#34;Beneficiary&#34; Defined
        </Typography>
        <Typography nextElement='typography'>
          The beneficiary of a policy is the person who receives the proceeds of an insurance policy upon the
          death of the insured. The beneficiary is named by the policyowner. The policyowner is the only
          person who can change the beneficiary.
        </Typography>
        <Typography
          component='h3'
          nextElement='typography'>
          Changing a Current Beneficiary&#39;s Name or Address
        </Typography>
        <Typography nextElement='typography'>
          You do not need to fill out a form if you are only changing the current beneficiary&#39;s name and/or
          address &#40;i.e. marriage, adoption, or other legal name change&#41;. Call your Northwestern Mutual
          representative, or contact Northwestern Mutual directly at <Link id='life-insurance-faq-change-beneficiary-form-toll-free-number-link' ariaLabel='Call to change the current beneficiary name or address' linkUrl='tel:8773949524' variant='primaryDeemphasize'>1&#45;877&#45;394&#45;9524</Link>, <time dateTime='7:00-06:00'>7am</time>&#8211;<time dateTime='18:00-06:00'>6pm</time> CT.
          Monday &#8211; Friday.
        </Typography>
        <Typography
          component='h3'
          nextElement='typography'>
          Change a Beneficiary
        </Typography>
        <Typography disableBottomPadding>
          To change the beneficiary, you will need to complete and sign a change of beneficiary form. Call
          your Northwestern Mutual representative, or contact Northwestern Mutual directly at
          <Link id='life-insurance-faq-change-beneficiary-toll-free-number-link' ariaLabel='Call to change the beneficiary' linkUrl='tel:8773949524' variant='primaryDeemphasize'>1&#45;877&#45;394&#45;9524</Link>, <time dateTime='7:00-06:00'>7am</time>&#8211;<time dateTime='18:00-06:00'>6pm</time> CT. Monday &#8211; Friday.
        </Typography>
      </Col>
    </Row>
  </SectionContainer>
);
